import { LANGUAGES } from '@core/constants/language.constants';

const SUPPORTED_H5P_LANGUAGES: string[] = Object.values(LANGUAGES);

export function getAssets(lang: string): {
  css: string[];
  editorCss: string[];
  js: string[];
  currentTranslation: string[];
  allTranslations: string[];
} {
  const h5pLang = SUPPORTED_H5P_LANGUAGES.includes(lang) ? lang : LANGUAGES.EN;

  return {
    css: [
      'core/dist/h5p.css',
      'core/dist/h5p-confirmation-dialog.css',
      'core/dist/h5p-custom-dialog.css',
      'core/dist/h5p-core-button.css',
    ],
    editorCss: [
      'editor/libs/darkroom.css',
      'editor/styles/css/h5p-hub-client.css',
      'editor/styles/css/fonts.css',
      'editor/styles/css/application.css',
      'editor/styles/css/libs/zebra_datepicker.min.css',
    ],
    js: ['core/dist/core-integration-bundle.js', 'editor/dist/bundle.js'],
    currentTranslation: [`editor/language/${h5pLang}.js`],
    allTranslations: SUPPORTED_H5P_LANGUAGES.map(
      l => `editor/language/${l}.js`,
    ),
  };
}
